export const translations = {
  bs: {
    nav: {
      home: 'Početna',
      menu: 'Meni',
      gallery: 'Galerija',
      about: 'O nama',
      contact: 'Kontakt',
      language: 'Jezik',
    },
    home: {
      slogan: 'Tradicija susreće ukus',
      description: 'Autentični bosanski pekarijski proizvodi, iz srca Berlina. Iskusite toplinu i ukus tradicionalne bosanske kuhinje.',
    },
    menu: {
      title: 'Naš meni',
      subtitle: 'Svježe pečeno sa ljubavlju i tradicijom',
      addToCart: 'Dodaj u korpu',
      addedToCart: 'Dodano u korpu!',
      itemsInCart: 'artikala u korpi',
      popular: 'Popularno',
      categories: {
        traditional: 'Burek & Pite',
        desserts: 'Kolači',
        hotMeals: 'Topla jela',
        drinks: 'Napitci',
      },
    },
    gallery: {
      title: 'Galerija',
      subtitle: 'Naše ukusne kreacije',
      view: 'Pogledaj',
    },
    about: {
      title: 'O nama',
      description: 'Bosna donosi autentični ukus Bosne u Berlin. Naša pekara kombinuje tradicionalne recepte sa modernom izradom.',
      story: 'Od otvaranja u srcu Berlina, posvetili smo se umjetnosti tradicionalnih bosanskih pekarijskih proizvoda. Svaki proizvod se pravi sa ljubavlju i prema porodičnim receptima koji se prenose generacijama. Od hrskavog bureka do slatkih krofni – donosimo dio bosanske kulture na vaš sto.',
      features: {
        traditional: {
          title: 'Tradicionalni recepti',
          description: 'Autentični bosanski recepti koji se prenose kroz generacije.',
        },
        quality: {
          title: 'Premium kvalitet',
          description: 'Samo najfiniji sastojci za najviši kvalitet i ukus.',
        },
        fresh: {
          title: 'Svježe svaki dan',
          description: 'Svi proizvodi se svježe prave svakodnevno u našoj pekari.',
        },
        family: {
          title: 'Porodični posao',
          description: 'Porodični biznis vođen sa srcem i strašću.',
        },
      },
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Posjetite nas ili nam pošaljite poruku',
      info: {
        address: 'Adresa',
        phone: 'Telefon',
        hours: 'Radno vrijeme',
        hoursValue: 'Uto–Ned 08:00–20:00',
      },
      form: {
        title: 'Pošalji poruku',
        description: 'Imate pitanja? Rado ćemo vam pomoći.',
        name: 'Ime',
        email: 'Email',
        message: 'Poruka',
        submit: 'Pošalji',
        success: 'Poruka poslana!',
        successDescription: 'Javićemo vam se uskoro.',
      },
    },
  },

  en: {
    nav: {
      home: 'Home',
      menu: 'Menu',
      gallery: 'Gallery',
      about: 'About',
      contact: 'Contact',
      language: 'Language',
    },
    home: {
      slogan: 'Tradition Meets Taste',
      description: 'Authentic Bosnian pastries, straight from the heart of Berlin. Experience the warmth and flavor of traditional Bosnian cuisine.',
    },
    menu: {
      title: 'Our Menu',
      subtitle: 'Freshly baked with love and tradition',
      addToCart: 'Add to Cart',
      addedToCart: 'Added to cart!',
      itemsInCart: 'items in cart',
      popular: 'Popular',
      categories: {
        traditional: 'Burek & Pies',
        desserts: 'Desserts',
        hotMeals: 'Hot Meals',
        drinks: 'Drinks',
      },
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Our delicious creations',
      view: 'View',
    },
    about: {
      title: 'About Us',
      description: 'Bosna brings the authentic taste of Bosnia to Berlin. Our bakery combines traditional recipes with modern craftsmanship.',
      story: 'Since opening in the heart of Berlin, we have dedicated ourselves to the art of traditional Bosnian pastries. Each pastry is made with love and according to family recipes passed down through generations. From crispy burek to sweet krofne – we bring a piece of Bosnian culture to your table.',
      features: {
        traditional: { title: 'Traditional Recipes', description: 'Authentic Bosnian recipes passed down through generations.' },
        quality: { title: 'Premium Quality', description: 'Only the finest ingredients for the highest quality and taste.' },
        fresh: { title: 'Daily Fresh', description: 'All products are freshly made daily in our bakery.' },
        family: { title: 'Family Business', description: 'A family-run business with heart and passion.' },
      },
    },
    contact: {
      title: 'Contact',
      subtitle: 'Visit us or send us a message',
      info: {
        address: 'Address',
        phone: 'Phone',
        hours: 'Opening Hours',
        hoursValue: 'Tue–Sun 08:00–20:00',
      },
      form: {
        title: 'Send Message',
        description: 'Have questions? We are happy to help.',
        name: 'Name',
        email: 'Email',
        message: 'Message',
        submit: 'Submit',
        success: 'Message sent!',
        successDescription: 'We will get back to you shortly.',
      },
    },
  },

  de: {
    nav: {
      home: 'Startseite',
      menu: 'Speisekarte',
      gallery: 'Galerie',
      about: 'Über uns',
      contact: 'Kontakt',
      language: 'Sprache',
    },
    home: {
      slogan: 'Tradition trifft Geschmack',
      description: 'Authentische bosnische Backwaren, direkt aus dem Herzen Berlins. Erleben Sie die Wärme und den Geschmack traditioneller bosnischer Küche.',
    },
    menu: {
      title: 'Unsere Speisekarte',
      subtitle: 'Frisch gebacken mit Liebe und Tradition',
      addToCart: 'In den Warenkorb',
      addedToCart: 'Zum Warenkorb hinzugefügt!',
      itemsInCart: 'Artikel im Warenkorb',
      popular: 'Beliebt',
      categories: {
        traditional: 'Burek & Pies',
        desserts: 'Desserts',
        hotMeals: 'Warme Gerichte',
        drinks: 'Getränke',
      },
    },
    gallery: {
      title: 'Galerie',
      subtitle: 'Unsere köstlichen Kreationen',
      view: 'Ansehen',
    },
    about: {
      title: 'Über uns',
      description: 'Bosna bringt den authentischen Geschmack Bosniens nach Berlin. Unsere Bäckerei verbindet traditionelle Rezepte mit modernem Handwerk.',
      story: 'Seit unserer Eröffnung im Herzen Berlins haben wir uns der Kunst der traditionellen bosnischen Backwaren verschrieben. Jedes Gebäck wird mit Liebe und nach überlieferten Familienrezepten hergestellt. Von knusprigem Burek bis zu süßen Krofne – wir bringen ein Stück bosnische Kultur in Ihre Küche.',
      features: {
        traditional: { title: 'Traditionelle Rezepte', description: 'Authentische bosnische Rezepte, die seit Generationen weitergegeben werden.' },
        quality: { title: 'Premium Qualität', description: 'Nur die besten Zutaten für höchste Qualität und Geschmack.' },
        fresh: { title: 'Täglich frisch', description: 'Alle Produkte werden täglich frisch in unserer Bäckerei hergestellt.' },
        family: { title: 'Familienbetrieb', description: 'Ein von der Familie geführtes Unternehmen mit Herz und Leidenschaft.' },
      },
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Besuchen Sie uns oder senden Sie uns eine Nachricht',
      info: {
        address: 'Adresse',
        phone: 'Telefon',
        hours: 'Öffnungszeiten',
        hoursValue: 'Di–So 08:00–20:00',
      },
      form: {
        title: 'Nachricht senden',
        description: 'Haben Sie Fragen? Wir helfen Ihnen gerne weiter.',
        name: 'Name',
        email: 'E-Mail',
        message: 'Nachricht',
        submit: 'Absenden',
        success: 'Nachricht gesendet!',
        successDescription: 'Wir werden uns in Kürze bei Ihnen melden.',
      },
    },
  },
};
